import { render, staticRenderFns } from "./logoShape.vue?vue&type=template&id=18d13df9&scoped=true"
import script from "./logoShape.vue?vue&type=script&lang=js"
export * from "./logoShape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d13df9",
  null
  
)

export default component.exports